export default {
  brandColor1: '#DCB2BE',
  complimentaryColor1: '#fff',
  brandColor2: '#242424',
  complimentaryColor2: '#fff',
};
